import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=f9ed715c&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=ts"
export * from "./Employee.vue?vue&type=script&lang=ts"
import style0 from "./Employee.vue?vue&type=style&index=0&id=f9ed715c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ed715c",
  null
  
)

export default component.exports